import { Stack } from '@mantine/core';
import { PriceOfferRow } from 'components/tables/data/price-offer/types';
import P1Regular from 'components/typography/P1Regular';
import P2Regular from 'components/typography/P2Regular';

interface BulkConfirmMessageProps {
  message: string;
  priceOffers: PriceOfferRow[];
}

/**
 * Bulk confirm message for all selected price offers.
 */
export default function BulkConfirmMessage({ message, priceOffers }: BulkConfirmMessageProps) {
  return (
    <Stack spacing={4}>
      <P1Regular mb={4}>{message}</P1Regular>
      <Stack spacing={2}>
        {priceOffers.map((priceOffer) => (
          <P2Regular key={priceOffer.priceOfferId} color="gray.8">
            #{priceOffer.priceOfferId} - {priceOffer.device.deviceName}
          </P2Regular>
        ))}
      </Stack>
    </Stack>
  );
}
